import React from "react";
import styles from "./CartSummary.module.css";

interface DesktopCartSummaryProps {
  isCheckoutDisabled: boolean;
  onCheckout: () => void;
  total: number;
  subtotal: number;
  totalProducts: number;
  totalDeliveryFee: number;
  isUpdatingFees: boolean;
  hasLocationSet: boolean;
  allGroupsHaveDeliveryFees: boolean;
  hasGroupsMissingDates?: boolean;
  showStatusMessages?: boolean;
}

const DesktopCartSummary: React.FC<DesktopCartSummaryProps> = ({
  isCheckoutDisabled,
  onCheckout,
  total,
  subtotal,
  totalProducts,
  totalDeliveryFee,
  isUpdatingFees,
  hasLocationSet,
  allGroupsHaveDeliveryFees,
  hasGroupsMissingDates = false,
  showStatusMessages = false,
}) => {
  return (
    <div className={styles.desktopSummary}>
      <div className={styles.summaryHeader}>
        <h2>Resumen de Pedido</h2>
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>
            {totalProducts} {totalProducts === 1 ? "producto" : "productos"}
          </span>
          <span className={styles.summaryValue}>
            {/* Always display the optimistic subtotal */}
            S/ {subtotal.toFixed(2)}
          </span>
        </div>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>Costo de envío</span>
          <span className={styles.summaryValue}>
            {!hasLocationSet ? (
              "Por calcular"
            ) : isUpdatingFees ? (
              <span className={styles.loadingFee}>
                <span className={styles.spinningIcon}></span>
                Calculando
              </span>
            ) : !allGroupsHaveDeliveryFees ? (
              "Por calcular"
            ) : totalDeliveryFee > 0 ? (
              `S/ ${totalDeliveryFee.toFixed(2)}`
            ) : (
              <span className={styles.freeShipping}>Gratis</span>
            )}
          </span>
        </div>
        <div className={`${styles.summaryRow} ${styles.totalRow}`}>
          <span className={styles.summaryLabel}>Total</span>
          <span className={styles.summaryValue}>
            {!hasLocationSet || isUpdatingFees || !allGroupsHaveDeliveryFees ? (
              <span className={styles.calculatingTotal}>
                {isUpdatingFees ? (
                  <>
                    <span className={styles.spinningIcon}></span>
                    Calculando
                  </>
                ) : (
                  "Por calcular"
                )}
              </span>
            ) : (
              <span className={styles.finalPrice}>S/ {total.toFixed(2)}</span>
            )}
          </span>
        </div>
      </div>
      <div className={styles.summaryFooter}>
        <button
          onClick={onCheckout}
          className={`buttonMain ${isCheckoutDisabled ? "disabled" : ""}`}
          disabled={isCheckoutDisabled || isUpdatingFees}
        >
          Proceder al pago
        </button>
        <p className={styles.termsText}>
          Al proceder, aceptas nuestros Términos y Condiciones.
        </p>
      </div>
    </div>
  );
};

export default DesktopCartSummary;
